import type { ReactNode } from "react";
import { cn } from "../lib/utils.js";

const TONES = {
  neutral: "bg-simuflex-mist text-simuflex-slate border border-simuflex-line",
  brand: "bg-simuflex-navy/5 text-simuflex-navy border border-simuflex-navy/20",
  success: "bg-simuflex-green/10 text-simuflex-forestGreen border border-simuflex-green/30",
  warning: "bg-simuflex-orange/10 text-simuflex-orange border border-simuflex-orange/30",
  danger: "bg-rose-50 text-rose-700 border border-rose-200/60",
} as const;

export type BadgeTone = keyof typeof TONES;

export function Badge({
  tone = "neutral",
  children,
  className,
}: {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold tracking-wide transition-colors",
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
